<template>
  <div class="tech-guide section-container">
    <div class="d-flex justify-space-between tech-guide-title">
      <header-title-two
        :loading="isLoading"
        title="Technical Guides"
      />
      <template v-if="technicalGuides.length > 0">
        <previous-next-navigation
          :navIndex="technicalGuidesSlide"
          :navLast="technicalGuides.length - numberOfSlides"
          v-on:on-prev="onNav('prev')"
          v-on:on-next="onNav('next')"
          class-name="align-center tech-nav justify-end"
        />
      </template>
    </div>
    <skeleton-card-list
      direction="horizontal"
      type="media"
      class="skeleton-helpful-hints flex-nowrap mt-1"
      isTechGuide
      isCard
      withoutMedia
      :loading="isLoading"
      :number="numberOfSlides"
    >
      <div class="tech-guide__content">
        <slick-carousel
          v-if="technicalGuides.length > 0"
          ref="slickCarousel"
          :itemsToShow="numberOfSlides"
          :settings="slickSettings"
          @afterChange="afterChange"
        >
          <card-five
            class="mr-6"
            v-for="item in technicalGuides"
            v-bind:key="item.id"
            :id="item.id"
            :title="item.title"
            :description="item.description"
            :file="item.url"
          />
        </slick-carousel>
      </div>
    </skeleton-card-list>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { TechGuidesApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import PreviousNextNavigation from '../../components/PreviousNextNavigation.vue';
import SkeletonCardList from '../../components/skeleton/CardList.vue';
import CardFive from '../../components/cards/card-5.vue';
import SlickCarousel from '../../components/carousel/SlickCarousel.vue';
import { defaultSlickSettings, getNumberOfSlides } from '../../utils/carousel';

const config = openApiConfig();

const techGuidesApi = new TechGuidesApi(config);

export default {
  components: {
    HeaderTitleTwo,
    SkeletonCardList,
    CardFive,
    PreviousNextNavigation,
    SlickCarousel,
  },
  data: () => ({
    technicalGuidesSlide: 0,
    isLoading: false,
    slickSettings: defaultSlickSettings([4, 4, 3, 2, 1.2]),
  }),
  computed: {
    ...mapGetters(['technicalGuides', 'windowWidth']),
    numberOfSlides () {
      return getNumberOfSlides(this.windowWidth, [1.2, 2, 3, 4]);
    }
  },
  mounted() {
    this.fetchTechGuides();
  },
  methods: {
    ...mapActions(['refreshTechGuides']),
    async fetchTechGuides() {
      this.isLoading = true;
      const accessToken = await this.$auth.getTokenSilently();
      const techGuides = await techGuidesApi
        .getTechnicalGuides({
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .catch(e => console.error(e));
      this.refreshTechGuides(techGuides?.data?.data ?? []);
      this.isLoading = false;
    },
    afterChange(slideNumber) {
      this.technicalGuidesSlide = slideNumber;
    },
    onNav(type) {
      switch (type) {
        case 'prev':
          this.$refs.slickCarousel.$children[0].prev();
          break;
        case 'next':
        default:
          this.$refs.slickCarousel.$children[0].next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tech-guide {
  width: calc(100% + 8px);
}
</style>
